import misc from "./Misc";
import registration from "./Registration";
import sidenav from "./Sidenav";
import overview from "./Overview";
import pos from "./POS";
import settings from "./Settings";
import transaction from "./Transaction";
import settlements from "./Settlements";
import promo from "./Promo";
import redemption from "./Redemption";
import credit from "./Credit";
import customers from './Customers.js'

const english = {
  translation: {
    sidenav,
    registration,
    overview,
    misc,
    pos,
    settings,
    transaction,
    settlements,
    promo,
    redemption,
    credit,
    customers
  }
}

export default english;